<div style="padding: 2rem;">

  <!-- Page header -->
  <div style="margin-bottom: 1.75rem;">
    <h1 style="font-size: 1.5rem; font-weight: 700; color: #1e293b; margin: 0 0 0.25rem;">
      Notifications
    </h1>
    <p style="font-size: 0.875rem; color: #64748b; margin: 0;">Gestion des notifications envoyées aux utilisateurs</p>
  </div>

  <!-- Main card -->
  <div class="afri-card">

    <!-- Card header: actions + count -->
    <div class="afri-card-header">
      <div class="flex items-center gap-2 flex-wrap" *ngIf="buttonsPermission">
        <button *ngIf="buttonsPermission.add" (click)="notifyOne(notifyUserContent)" class="btn-afri-primary">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
          </svg>
          Notifier un utilisateur
        </button>
        <button *ngIf="buttonsPermission.add" (click)="notifyEveryone(notifyAllContent)" class="btn-afri-outline">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
          </svg>
          Notifier tout le monde
        </button>
        <button *ngIf="buttonsPermission.delete" (click)="delete()" class="btn-afri-danger">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
          </svg>
          Supprimer
        </button>
        <button *ngIf="buttonsPermission.delete" (click)="deleteAll()" class="btn-afri-danger">
          Supprimer tout
        </button>
      </div>
      <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
        <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ data!.length }}</span>
        élément(s)
        <app-loading [isVisible]="loading2"></app-loading>
      </div>
    </div>

    <!-- Table -->
    <div style="overflow-x: auto;">
      <table class="afri-table">
        <thead>
          <tr>
            <th style="width: 52px; padding-left: 1.5rem;">#</th>
            <th>Titre</th>
            <th>Contenu</th>
            <th>Destinataire</th>
            <th>Type</th>
            <th>Statut</th>
            <th>Envoyée le</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let d of data | paginate: {
                id: 'ngxP1',
                itemsPerPage: pg.pageSize,
                currentPage: pg.p,
                totalItems: pg.total
              } | sampleSearch:search_text"
              [style.background]="selected_data?.id === d.id ? '#f0f4ff' : ''">
            <td style="padding-left: 1.5rem;">
              <input (click)="checked(d)" type="radio" name="selectRow"
                     style="width: 16px; height: 16px; accent-color: #2E3190; cursor: pointer;">
            </td>
            <td>{{d.title}}</td>
            <td>{{d.content}}</td>
            <td>{{d.target_id == 0 || d.target == 0 ? 'Tout le monde' : ('Utilisateur #' + (d.target_id ?? d.target))}}</td>
            <td>{{d.type}}</td>
            <td><app-status [value]="d.status"></app-status></td>
            <td>{{d.created_at | date:"dd/MM/yyyy HH:mm"}}</td>
          </tr>

          <tr *ngIf="data.length === 0 && !loading2">
            <td colspan="7" style="padding: 4rem 1.25rem; text-align: center;">
              <div style="display: flex; flex-direction: column; align-items: center; gap: 0.75rem; color: #94a3b8;">
                <svg class="w-12 h-12" style="color: #e2e8f0;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                </svg>
                <p style="margin: 0; font-weight: 500;">Aucun élément trouvé</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div style="padding: 0.5rem 1.5rem 1.25rem;">
      <pagination-controls
        id="ngxP1"
        (pageChange)="getPage($event)"
        [maxSize]="9"
        [directionLinks]="true"
        [autoHide]="true"
        [responsive]="true"
        [previousLabel]="'Précédent'"
        [nextLabel]="'Suivant'">
      </pagination-controls>
    </div>

  </div>
</div>

<ng-template #notifyUserContent let-c="close" let-d="dismiss">
  <form #notifyForm="ngForm" (ngSubmit)="notifyUser(notifyForm.value); dismiss()">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Notifier un utilisateur</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Utilisateur <span class="text-danger ml-2">(*)</span></label>
          <select class="afri-input" [(ngModel)]="selectedUserId" name="user_id" required>
            <option [value]="null" disabled>Sélectionner un utilisateur</option>
            <option *ngFor="let u of users" [value]="u.id">{{u.name}} ({{u.phone_number}})</option>
          </select>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Titre <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="title" class="afri-input" ngModel required>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Message <span class="text-danger ml-2">(*)</span></label>
          <textarea name="content" class="afri-input" rows="4" ngModel required></textarea>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn-afri-primary" [disabled]="notifyForm.invalid || !selectedUserId">
        Envoyer <app-loading [isVisible]="loading"></app-loading>
      </button>
    </div>
  </form>
</ng-template>

<ng-template #notifyAllContent let-c="close" let-d="dismiss">
  <form #notifyAllForm="ngForm" (ngSubmit)="notifyAll(notifyAllForm.value); dismiss()">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Notifier tout le monde</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="afri-label">Titre <span class="text-danger ml-2">(*)</span></label>
          <input type="text" name="title" class="afri-input" ngModel required>
        </div>
        <div class="col-12 mb-3">
          <label class="afri-label">Message <span class="text-danger ml-2">(*)</span></label>
          <textarea name="content" class="afri-input" rows="4" ngModel required></textarea>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn-afri-primary" [disabled]="notifyAllForm.invalid">
        Envoyer à tout le monde <app-loading [isVisible]="loading"></app-loading>
      </button>
    </div>
  </form>
</ng-template>
